/* eslint-disable @typescript-eslint/no-explicit-any */
import { datadogLogs } from '@datadog/browser-logs'
import { datadogRum } from '@datadog/browser-rum'

export const { addAction, addError } = datadogRum

declare global {
  interface Navigator {
    brave?: {
      isBrave: () => Promise<boolean>
    }
  }
}

export const logger = datadogLogs.logger

export const addCustomAction = (message: string, messageContext?: object) => {
  const context = messageContext ?? {}
  const contextTimestamp = { ...context, traceTimestamp: Date.now() }
  addAction(message, contextTimestamp)
}

export const addLogger = (message: string, messageContext?: object, error?: Error) => {
  const context = messageContext ?? {}
  const contextTimestamp = { ...context, traceTimestamp: Date.now() }

  if (error) {
    logger.error(message, contextTimestamp, error)
  } else {
    logger.info(message, contextTimestamp)
  }
}

export async function identifyBrowser() {
  const ua = navigator.userAgent

  try {
    if (navigator['brave'] && typeof navigator.brave.isBrave === 'function') {
      const isBrave = await navigator.brave.isBrave()
      if (isBrave) return 'Brave'
    }

    if (ua.includes('OPR/') || (!!(window as any).opr && (window as any).opr.addons)) return 'Opera'
    if (ua.includes('Edg/')) return 'Edge'
    if (ua.includes('Firefox/')) return 'Firefox'

    const isSafari = /^((?!chrome|android|crios|fxios|edg|opr|vivaldi).)*safari/i.test(ua)
    if (isSafari) return 'Safari'

    const brandsLength = navigator.userAgentData?.brands?.length ?? 0

    if (brandsLength < 3) return 'Based on Chrome'

    if (ua.includes('Chrome/')) return 'Chrome'

    return 'Unknown'
  } catch {
    return 'Unknown'
  }
}
